export default __webpack_public_path__ + "static/gcash-7e4b7672cce5db79e9de8f33dafdd6fe.webp";